import React from 'react';
import { ButtonV2 } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';
import { SkeletonText } from '@shared/components/Skeleton';
import type { HotelTileCTAProps } from '../HotelTileCard.types';

export const HotelTileCTA: React.FC<HotelTileCTAProps> = ({ title, variant = 'solid', onClick }) => {
  return (
    <ButtonV2
      intent="neutral"
      shape="rounded"
      fontWeight={600}
      fontSize={pxToRem(16)}
      fontFamily="Inter UI"
      variant={variant}
      width="100%"
      onClick={onClick}
    >
      {title}
    </ButtonV2>
  );
};

// Skeleton component for HotelTileCTA
export const HotelTileCTASkeleton: React.FC = () => {
  return (
    <SkeletonText
      rows={1}
      width="100%"
      skeletonHeight={pxToRem(44)}
    />
  );
};
